import React, { useEffect, useState } from 'react';
import { useGetLogsPreviewQuery } from '../api/api';
import { useListView } from '../../../utility/ListView';
import { FileContentResultResult } from '../../../api/data-contracts';

interface ExtendedFileContentResultResult extends FileContentResultResult {
	fileContents: string;
}

// https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
// This function is used to decode base64 encoded strings that contain unicode characters
function b64DecodeUnicode(str: string) {
	// Going backwards: from bytestream, to percent-encoding, to original string.
	return decodeURIComponent(atob(str).split('').map(function (c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));
}

function LogViewer() {
	const { id } = useListView();

	if (!id) {
		return <>No ID provided</>;
	}

	const { data, isFetching, error } = useGetLogsPreviewQuery({ id });
	const [content, setContent] = useState('');
	const [filteredContent, setFilteredContent] = useState('');
	const [searchTerm, setSearchTerm] = useState('');

	useEffect(() => {
		if (!data || !data.data) {
			return;
		}

		const fileContents = (data.data as any as ExtendedFileContentResultResult).fileContents;
		let decodedContent = b64DecodeUnicode(fileContents);

		setContent(decodedContent);
		setFilteredContent(decodedContent)
	}, [data]);

	useEffect(() => {
		if (searchTerm === '') {
			setFilteredContent(content); // no search term means show all content
		} else {
			const lines = content.split('\n');
			const filteredLines = lines.filter(line => line.toLowerCase().includes(searchTerm.toLowerCase()));
			setFilteredContent(filteredLines.join('\n'));
		}
	}, [searchTerm, content]);

	if (isFetching) {
		return <div className="d-flex justify-content-center">
			<div className="overlay-layer rounded bg-dark bg-opacity-5">
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden">Loading...</span>
				</div>
			</div>
		</div>;
	}

	if (error) {
		return <div className="d-flex justify-content-center">No log file found for this task</div>;
	}

	return (
		<div>
			<input
				type="text"
				className="form-control mb-3"
				placeholder="Search in logs..."
				value={searchTerm}
				onChange={(e) => setSearchTerm(e.target.value)}
			/>
			<div className="p-3  border">
				<pre className="mb-0">{filteredContent}</pre>
			</div>
		</div>
	);
}

export default LogViewer;